import { render } from "./AdminBills.vue?vue&type=template&id=04797e22&ts=true&lang=pug"
import script from "./AdminBills.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminBills.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__